document.addEventListener('DOMContentLoaded', () => {
  app()
})

const transitionEnableLoader = () =>{
  const loaderForm = document.querySelector('#loaderForm')
  const formProgramas = document.querySelector('#formularioProgramas')

  formProgramas.classList.add('d-none')
  loaderForm.classList.remove('d-none')
}

const transitionEnableLoaderCanvas = () =>{
  const loaderCanvas = document.querySelector('#loaderCanvas')
  const parentCardsProgramas = document.querySelector('#parentCardsProgramas')

  parentCardsProgramas.classList.add('d-none')
  loaderCanvas.classList.remove('d-none')
}

const transitionDisableLoader = () =>{
  const loaderForm = document.querySelector('#loaderForm')
  const formProgramas = document.querySelector('#formularioProgramas')

  loaderForm.classList.add('d-none')
  formProgramas.classList.remove('d-none')
}

const transitionDisableLoaderCanvas = () =>{
  const loaderCanvas = document.querySelector('#loaderCanvas')
  const parentCardsProgramas = document.querySelector('#parentCardsProgramas')

  loaderCanvas.classList.add('d-none')
  parentCardsProgramas.classList.remove('d-none')
}

const hideAllLoader = () => {
  const loaderForm = document.querySelector('#loaderForm')
  const formProgramas = document.querySelector('#formularioProgramas')

  loaderForm.classList.add('d-none')
  formProgramas.classList.add('d-none') 
}

const hideAllLoaderCanvas = () => {
  const loaderCanvas = document.querySelector('#loaderCanvas')
  const parentCardsProgramas = document.querySelector('#parentCardsProgramas')

  loaderCanvas.classList.add('d-none')
  parentCardsProgramas.classList.add('d-none') 
}

const msnFilterProgramaSena = (text, display) => {
  const msnFilter = document.querySelector('#msnFilter')

  if(display === "show"){
    msnFilter.classList.remove('d-none')
  }
  else{
    msnFilter.classList.remove('add')
  }

  msnFilter.textContent = `${text}`
}

const consultarByTipoProgramaSena = (tipoPrograma) => {
  fetchDataProgramaSena(tipoPrograma)
}

const consultarByprogramasUnitecIds = (programasId, tipoPrograma) => {
  fetchDataProgramaUnitec(programasId, tipoPrograma)
}

const fetchDataProgramaSena = async (filter) =>  {
  try {
    const response = await fetch(`/api/programas-sena-${filter}`);
    // console.log(response)
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const formatResponse = await response.json();
    // console.log(formatResponse)

    renderFilterSena(formatResponse)

    // return formatResponse
  } catch (error) {
    console.error('Error fetching user data:', error);
  }
}

const fetchDataProgramaUnitec = async (programasId, tipoPrograma) => {
  try {
    const response = await fetch(`/api/programas-unitec`);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const formatResponse = await response.json();

    renderFilterUnitec(formatResponse, programasId, tipoPrograma)

    // return formatResponse
  } catch (error) {
    console.error('Error fetching user data:', error);
  }
}

// const getOptionsProgramaSena = () => {
//   const programaSenaOptions = document.querySelectorAll('#programaSena option')
//   return programaSenaOptions
// }
const resetCanvasProgramasUnitec = () => {
  const parentCardsProgramas = document.querySelector('#parentCardsProgramas')
  parentCardsProgramas.innerHTML = ''
}


const renderFilterSena = (pullData) => {
  const programaSenaSelect = document.querySelector('#programaSena')
  const existingOptionValues = Array.from(programaSenaSelect.options).map(option => option.value)

  transitionEnableLoader()
  
  function createOptions(){
    pullData.forEach((item) => {
      if(!existingOptionValues.includes(item.nombre)) {
        const option = document.createElement('option');
        option.value = item.nombre
        option.dataset.tipoPrograma = item.tipoPrograma
        option.dataset.programasUnitecIds = item.programasUnitecIds
        option.textContent = item.nombre
        programaSenaSelect.appendChild(option)
      }
    })
  }

  function deleteOptions(){
    for (let i = programaSenaSelect.options.length - 1; i > 0; i--) {
      programaSenaSelect.remove(i);
      // console.log(`Programa ${i} Borrado Exitosamente`)
    }

  }

  function resetProgramaSenaSelect(){
    deleteOptions()
    programaSenaSelect.selectedIndex = 0;
    resetCanvasProgramasUnitec()
    msnFilterProgramaSena('', 'hide')
  }

  if(pullData.length > 0){
    resetProgramaSenaSelect()
    
    createOptions()

    setTimeout(() => {
      transitionDisableLoader()
      msnFilterProgramaSena('', 'hide')
    }, 2000);
  }
  else{
    resetProgramaSenaSelect()

    transitionEnableLoader()
    setTimeout(() => {
      hideAllLoader()
      msnFilterProgramaSena('El programa a homologar no se encuentra disponible.', 'show')
    }, 2000);
  }

}

const crearCard = (programa, parentCardsProgramas) => {
  msnFilterProgramaSena('', 'hide')

  const cardPrograma = document.createElement('DIV')
  cardPrograma.classList.add('item-box')

  const cardImg = document.createElement('IMG')
  cardImg.setAttribute('src', `${programa.imageUrl}`)
  cardImg.classList.add('d-block')
  cardImg.classList.add('w-100')

  const cardBody = document.createElement('DIV')
  cardBody.classList.add('card-body')

  const cardTitle = document.createElement('H5')
  cardTitle.textContent = `${programa.nombre}`

  const cardTxSemestre = document.createElement('P')
  cardTxSemestre.innerHTML = `<strong>Ingresas a:</strong> ${programa.semestreIngreso}`

  const cardTxModalidad = document.createElement('P')
  cardTxModalidad.innerHTML = `<strong>Modalidad:</strong> ${programa.modalidad}`

  const cardTxDuracion = document.createElement('P')
  cardTxDuracion.innerHTML = `<strong>Duración:</strong> ${programa.duracion}`

  const cardTxEnlace = document.createElement('A')
  cardTxEnlace.classList.add('boton-landing')
  cardTxEnlace.setAttribute('target', `_blank`)
  cardTxEnlace.setAttribute('href', `${programa.url}`)
  cardTxEnlace .textContent = `Ver programa`

  parentCardsProgramas.appendChild(cardPrograma)

  cardPrograma.appendChild(cardImg)
  cardPrograma.appendChild(cardBody)

  cardBody.appendChild(cardTitle)
  cardBody.appendChild(cardTxSemestre)
  cardBody.appendChild(cardTxModalidad)
  cardBody.appendChild(cardTxDuracion)
  cardBody.appendChild(cardTxEnlace)

}

const validatePrograma = (programa, parentCardsProgramas, itemProgramaId, lengthIds) => {
  if(programa.id === itemProgramaId){
    if(programa.estado === 'Activo'){
      crearCard(programa, parentCardsProgramas)
    }
    else if(programa.estado === 'Activo'){
      crearCard(programa, parentCardsProgramas)
    }
    else if(programa.estado === 'Deshabilitado' && lengthIds < 2){
      setTimeout(() => {
        msnFilterProgramaSena('El programa a homologar no se encuentra disponible.', 'show')
      }, 2000);
    } 
  }
}

const renderFilterUnitec = (pullData, programasId, tipoPrograma) => {
  const parentCardsProgramas = document.querySelector('#parentCardsProgramas')
  resetCanvasProgramasUnitec()
  
  const listaProgramasId = programasId.split(",")
  // console.log(tipoPrograma)

  const programasTecnico = pullData.filter(programa => programa.tipoPrograma === 'Técnico')
  const programasTecnologo = pullData.filter(programa => programa.tipoPrograma === 'Tecnólogo')

  // console.log(pullData)
  listaProgramasId.forEach(itemProgramaId => {
    // pullData.forEach((programa) => {
    if(tipoPrograma === 'Técnico'){
      programasTecnico.forEach((programaTecnico) => {
        validatePrograma(programaTecnico, parentCardsProgramas, itemProgramaId, listaProgramasId.length)
      })
    }  
    else if(tipoPrograma === 'Tecnólogo'){
      programasTecnologo.forEach((programaTecnologo) => {
        validatePrograma(programaTecnologo, parentCardsProgramas, itemProgramaId, listaProgramasId.length)
      })
    } 
    // })  
  })   

  listaProgramasId.forEach(itemProgramaId => {
    if(pullData.length > 0 && itemProgramaId !== '0'){    
      transitionEnableLoaderCanvas()
      setTimeout(() => {
        transitionDisableLoaderCanvas()
      }, 2000);
    }
    else{
      hideAllLoaderCanvas()
      resetCanvasProgramasUnitec()
    }
  }) 
}

const searchProgramasSena = () => {
  const filterTecnico = document.querySelector('#filterTecnico')
  const filterTecnologo = document.querySelector('#filterTecnologo')

  let counterButtonFilterTecnico = 0
  let counterButtonFilterTecnologo = 0

  filterTecnico.addEventListener('click', () => {
    counterButtonFilterTecnico++
    if(counterButtonFilterTecnico === 1){
      counterButtonFilterTecnologo = 0

      filterTecnologo.classList.remove('active')
      filterTecnico.classList.add('active')

      consultarByTipoProgramaSena(filterTecnico.dataset.tipoPrograma)
    }
  })

  filterTecnologo.addEventListener('click', () => {
    counterButtonFilterTecnologo++
    if(counterButtonFilterTecnologo === 1){
      counterButtonFilterTecnico = 0

      filterTecnico.classList.remove('active')
      filterTecnologo.classList.add('active')

      consultarByTipoProgramaSena(filterTecnologo.dataset.tipoPrograma)
    }
  })
}

const searchProgramasUnitec = () => {
  const programaSenaSelect = document.querySelector('#programaSena')
  
  programaSenaSelect.addEventListener("change", (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const getprogramasUnitecIds = selectedOption.dataset.programasUnitecIds
    const getTipoPrograma = selectedOption.dataset.tipoPrograma

    if(programaSenaSelect.value === ''){
      msnFilterProgramaSena('Selecciona un programa', 'show')
      consultarByprogramasUnitecIds('0')
    }
    else{
      msnFilterProgramaSena('', 'hide')
      consultarByprogramasUnitecIds(getprogramasUnitecIds, getTipoPrograma)
    }

  })
}

const app = () => {
  searchProgramasSena()
  searchProgramasUnitec()
}